let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aMQwG")).then(() => parcelRequire('fsKGx'));